<template>
  <DashboardMenu />
  <div class="w-4/5 bg-gray-100 p-4 pt-1">
    <Suspense>
      <div>
        <div v-if="!loadingStore.loading">
          <slot />
        </div>
        <LoadingBlock v-else />
      </div>
      <template #fallback>
        <LoadingBlock />
      </template>
    </Suspense>
  </div>
</template>

<script setup>
import { useLoadingStore } from '@/stores/loading';

import DashboardMenu from './DashboardMenu.vue'
import LoadingBlock from './LoadingBlock.vue';

const loadingStore = useLoadingStore()

defineProps({
  title: {
    type: String,
    default: null
  }
})
</script>